import React from 'react'
import {Icon} from '@chakra-ui/react'

const RadioIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" fill="none" {...props}>
            <circle cx="12" cy="12" r="10.5" stroke="black" />
            <circle cx="12" cy="12" r="5" fill="black" />
        </Icon>
    )
}

export default RadioIcon
